export function parseInspectionPlanDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const inspectionPlanIdRaw = params.get('inspectionPlanId');
  const partIdRaw = params.get('partId');
  const partNumber = (params.get('partNumber') || '').trim();
  const inspectionPlanId = inspectionPlanIdRaw ? Number(inspectionPlanIdRaw) : null;
  const partId = partIdRaw ? Number(partIdRaw) : null;

  if (!(Number.isFinite(inspectionPlanId) && inspectionPlanId > 0) && !(Number.isFinite(partId) && partId > 0) && !partNumber) {
    return null;
  }

  return {
    inspectionPlanId: Number.isFinite(inspectionPlanId) && inspectionPlanId > 0 ? inspectionPlanId : null,
    partId: Number.isFinite(partId) && partId > 0 ? partId : null,
    partNumber,
  };
}
